<template>
  <div class="modal fade" :id="option.id" role="dialog">
    <div class="modal-dialog choose-modal">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title text-left">{{option.title}}
            <div class="input-group pull-right m-r-15" style="width: 200px;">
              <span class="input-group-addon"><i class="fa fa-search"></i></span>
              <input class="form-control" type="text" v-model="searchLabel">
            </div>
          </h4>
        </div>
        <div class="modal-body text-left">
          <!--
          <div class="bg-primary text-16" style="padding: 10px">
            備註： {{elementRemark}}
          </div>
          -->
          <div class="text-left">
            <button class="btn btn-default btn-choose-element" v-for="elem in filteredList" @click="clickElement(elem)" :class="{active: elem.active}"
                    @mouseover="showRemark(elem)" @mouseleave="hideRemark()" v-if="curId !== elem.item_id"
            >
              {{elem.name}}<span v-if="showMoney">&nbsp;&nbsp;${{getPrice(elem.price)}}</span><br>
              <div class="text-remark-wrap"><small>&nbsp;{{elem.remark}}&nbsp;</small></div>
            </button>
            <p class="text-danger text-center" v-if="!elementList.length">無法{{option.title}}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-danger" data-dismiss="modal" @click="clearAll">全取消</button>
          <button class="btn btn-default" data-dismiss="modal" v-if="!hideCancel">取消</button>
          <button class="btn btn-primary" data-dismiss="modal" @click="trigger(option.event)">
            確定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    option: {
      type: Object,
      required: true
    },
    elementList: Array,
    showMoney: Boolean,
    hideCancel: Boolean,
    curId: [Number, String]
  },
  data () {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: '',
      searchLabel: ''
    }
  },
  computed: {
    filteredList () {
      var self = this
      return this.elementList.filter(function (elem) {
        if (elem.name.toLowerCase().includes(self.searchLabel.toLowerCase()) || elem.remark.toLowerCase().includes(self.searchLabel.toLowerCase())) return elem
      })
    }
  },
  methods: {
    showRemark (elem) {
      this.elementRemark = elem.remark
    },
    hideRemark () {
      this.elementRemark = ''
    },
    trigger (event) {
      this.$emit('trigger', event)
    },
    clickElement (elem) {
      this.elementList.find(function (o) {
        if (parseInt(o.item_id, 10) === parseInt(elem.item_id, 10)) {
          var active = !o.active
          o.active = active
          // 選擇商品用
          if (typeof o.newPrice !== 'undefined') o.newPrice = o.price
          if (o.child_list) {
            o.child_list.forEach(function (child) {
              child.active = active
            })
          }
        }
      })
    },
    clearAll () {
      for (var i = 0; i < this.elementList.length; i++) {
        this.elementList[i].active = false
      }
    },
    getPrice (price) {
      return Math.floor(price * 100) / 100
    }
  }
}
</script>
<style lang="sass">
.text-remark-wrap
  opacity: .7
  overflow: hidden
  text-overflow: ellipsis
  white-space: pre-wrap
.element-block
  border: 1px solid #eee
  padding: 30px 15px
.choose-modal.modal-dialog
  width: 80%
  min-height: 80vh
  .modal-content
    min-height: 80vh
.btn-choose-element
  margin: 8px
  padding: 10px
  font-size: 18px
  width: calc(20% - 16px)
.btn-choose-element.active
  background-color: #3c8dbc !important
  border-color: #367fa9 !important
  color: #ffffff !important
@media screen and (max-width: 767px)
  .choose-modal.modal-dialog
    width: calc(100vw - 20px)
  .btn-choose-element
    font-size: 16px
    width: calc(100% - 16px)
@media screen and (max-width: 991px)
  .btn-choose-element
    font-size: 16px
    width: calc(50% - 16px)
</style>



// WEBPACK FOOTER //
// ChooseModal.vue?8ed47df8